import { createSelector } from '@ngrx/store';
import { selectShare } from './share.selector';

export const selectShareCopy = createSelector(
  selectShare,
  (share:any) => {
    const {
      shareCopyJobId,
      shareCopyStatus,
      shareCopyNodeId,
    } = share;

    return {
      shareCopyJobId,
      shareCopyStatus,
      shareCopyNodeId,
    };
  }
);
